import { darkScrollbar } from '@mui/material';
import { createTheme, alpha } from '@mui/material/styles';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const theme = createTheme({
    palette: {
        primary: {
            light: '#E1F1EC',
            main: '#74CCD6',
            dark: '#3a929c',
            contrastText: '#fff',
        },
        secondary: {
            light: '#DEE2E5',
            main: '#43464d',
            dark: '#1A1D23',
            contrastText: '#fff',
        },
        text: {
            primary: '#1A1D23',
        },
    },
});

const customScrollbar = () => ({
    '*::-webkit-scrollbar': {
        width: 8,
        height: 8,
    },
    '*::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
        borderRadius: 8,
    },
    '*::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.grey[700],
        borderRadius: 8,
    },
});

theme.components = {
    ...theme.components,
    MuiCssBaseline: {
        styleOverrides: {
            html: theme.palette.mode === 'dark' ? darkScrollbar() : customScrollbar(),
            '#root': {
                height: '100%',
                minHeight: '100vh',
            },
        },
    },
    MuiPaper: {
        styleOverrides: {
            rounded: {
                borderRadius: 8,
            },
        },
    },
};

export default theme;
